import { Button, Empty, Space, Typography } from 'antd'
import restrictedAccess from '../../resources/img/restricted-access.svg'
import { signOut, getAuth } from 'firebase/auth'
import * as Sentry from '@sentry/react'
import { useTranslation } from 'react-i18next'
import ImpersonationExitButton from '../ImpersonationExitButton'

export default function AccessDeniedComponent({ auth }) {
  const { t } = useTranslation()
  return (
    // <Card bordered={false}>
    <Empty
      imageStyle={{
        height: 400,
      }}
      image={restrictedAccess}
      description={
        <div style={{ maxWidth: '35em', margin: '0 auto' }}>
          <Typography.Title level={3}>403</Typography.Title>
          <Typography.Paragraph>
            {t('frontend:admin.accessDenied.description')}
          </Typography.Paragraph>
        </div>
      }
    >
      <Space direction="vertical">
        <Button
          type="primary"
          size="large"
          onClick={() => window.location.reload(true)}
        >
          {t('frontend:admin.accessDenied.reload')}
        </Button>
        <ImpersonationExitButton auth={auth} />
        <Button
          block
          danger
          onClick={async () => {
            Sentry.setUser(null)
            await signOut(auth || getAuth())
            window.location.reload()
          }}
        >
          {t('frontend:admin.accessDenied.logout')}
        </Button>
      </Space>
    </Empty>
    // </Card>
  )
}
